import axios from "axios";
import config from "../config";

const http = axios.create({
  baseURL: config.apiBaseUrl,
});

// auto attach token
http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default http;
